import { useQuery } from "@tanstack/react-query";
import { useApiClient } from "../../../apiClient";
import {
    GetLatestBookedGamesInputDto,
    GetLatestBookedGamesOutputDto
} from "../../../models/game/dto/get-latest-booked-games.dto";

export const GET_LATEST_BOOKED_GAMES_QUERY_KEY = (page: number, limit: number, organizationId?: string) =>
  ['games', 'latest-booked', page, limit, organizationId] as const;

export const useGetLatestBookedGames = (params: GetLatestBookedGamesInputDto) => {
  const client = useApiClient();

  const page = params.page ?? 0;
  const limit = params.limit ?? 10;
  const organizationId = params.organizationId;

  return useQuery({
    queryKey: GET_LATEST_BOOKED_GAMES_QUERY_KEY(page, limit, organizationId),
    enabled: !!organizationId,
    queryFn: async () => {
      const queryParams = new URLSearchParams();
      queryParams.append('page', page.toString());
      queryParams.append('limit', limit.toString());
      if (organizationId) {
        queryParams.append('organizationId', organizationId);
      }

      const endpoint = `games/latest-booked?${queryParams.toString()}`;

      return client.fetchApi<GetLatestBookedGamesOutputDto, {}>({
        endpoint,
        method: 'GET'
      });
    },
    staleTime: 30 * 1000, // 30 seconds
    cacheTime: 5 * 60 * 1000, // Keep in cache for 5 minutes
    keepPreviousData: true, // Keep showing previous data while loading new page
  });
};
